import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OBannerText as OBannerTextComp, OBannerTextAccentLine, AAccentLineSize } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

const TEST_ID = 'designsystem-components-OBannerText';

export const OBannerTextConfig = {
  emptyLabel: 'OBannerText',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/bannertext`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OBannerText = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;
  const filteredClassNames = (styleclass || '')
    .split(' ')
    .filter((cls: string) => cls !== 't-horizontal-vertical-rule' && cls !== 't-accent-color')
    .join(' ');

  // Accent Line options only come through via styleclass, so we derive props here
  const aAccentLine: OBannerTextAccentLine = {
    show: /ruler-height-[135]/.test(filteredClassNames),
    size: filteredClassNames.includes('ruler-height-5')
      ? AAccentLineSize.FivePx
      : styleclass?.includes('ruler-height-3')
      ? AAccentLineSize.ThreePx
      : AAccentLineSize.OnePx,
  };

  return (
    <div
      data-testid={TEST_ID}
      data-component-name={`o-${TEST_ID}`}
      id={componentId}
      className={clsx(filteredClassNames)}
    >
      <EditableComponent config={OBannerTextConfig} {...props}>
        <OBannerTextComp
          aAccentLine={aAccentLine}
          className={filteredClassNames.includes('m-container-fullbleed') ? '' : 'px-0'}
          {...props}
        />
      </EditableComponent>
    </div>
  );
};
